export default "__VITE_ASSET__6f736857__"